import api from './api';

export interface TenantEmailSettingsStatus {
  configurado: boolean;
  fromEmail?: string | null;
  fromName?: string | null;
  smtpServer?: string | null;
  smtpPort?: number | null;
  enableSsl?: boolean | null;
  username?: string | null;
  tieneContrasena: boolean;
  actualizadoEn?: string | null;
  actualizadoPor?: string | null;
}

export interface TenantEmailSettingsSave {
  smtpServer: string;
  smtpPort: number;
  username: string;
  appPassword?: string;
  fromEmail: string;
  fromName?: string;
  enableSsl: boolean;
}

const tenantEmailSettingsService = {
  async getStatus(): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.get<TenantEmailSettingsStatus>('/api/tenant/email-settings');
    return data;
  },

  async save(payload: TenantEmailSettingsSave): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.put<TenantEmailSettingsStatus>('/api/tenant/email-settings', payload);
    return data;
  },

  async remove(): Promise<void> {
    await api.delete('/api/tenant/email-settings');
  },
};

export default tenantEmailSettingsService;
